import { render, staticRenderFns } from "./ModalDrafts.vue?vue&type=template&id=2084b87c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ModalDrafts.vue?vue&type=script&lang=js&"
export * from "./ModalDrafts.vue?vue&type=script&lang=js&"
import style0 from "./ModalDrafts.vue?vue&type=style&index=0&id=2084b87c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2084b87c",
  null
  
)

export default component.exports